const wrapper = "_mww1jma4wr";
const closeButton = "_mwc10oqlaa";
const heading = "_mwh1j0sk9d";
const imageWrapper = "_mwilt391i";
const imageFigure = "_mwi5bit6c";
const image = "_mwiiihdw7";
const imageCaption = "_mwi1fhoon3";
const audio = "_mwacno4g";
const contextMenu = "_mwc111iktl";
const body = "_mwbp4utj2";
const linkButton = "_mwlc2z0zs";

export { audio, body, closeButton, contextMenu, heading, image, imageCaption, imageFigure, imageWrapper, linkButton, wrapper };
import "./molecule.hotspot-content.styles.linaria.module.css";
//# sourceMappingURL=molecule.hotspot-content.styles.js.map
